package features.members.ui.modals

import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager

object AddMemberModal {
    fun render(root: HTMLElement) {
        root.append {
            div("modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-md z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "add-member-modal"
                
                div("flex justify-between items-center mb-6") {
                    h3("text-xl font-bold") { +"Add Team Member" }
                    button(classes = "text-slate-400 hover:text-white") {
                        onClickFunction = { ModalManager.close() }
                        +"✕"
                    }
                }
                
                div("space-y-4 mb-6") {
                    div {
                        label("block text-sm text-slate-400 mb-1") { +"Email Address" }
                        input(type = InputType.email, classes = "w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                            id = "member-email-input"
                            placeholder = "user@example.com"
                            attributes["oninput"] = "validateUserEmail(this.value)"
                        }
                        // Validation message
                        div("mt-1 text-sm text-slate-400 hidden") {
                            id = "email-validation-message"
                            +"Checking user..."
                        }
                    }
                    div("grid grid-cols-2 gap-4") {
                        div {
                            label("block text-sm text-slate-400 mb-1") { +"Role" }
                            select("w-full bg-dark-900 border border-dark-700 rounded-xl p-3 focus:outline-none focus:border-brand-cyan text-white") {
                                id = "member-role-input"
                                option { value = "member"; +"Member" }
                                option { value = "admin"; +"Admin" }
                                option { value = "owner"; +"Owner" }
                            }
                        }
                    }
                }
                
                div("flex justify-end gap-3") {
                    button(classes = "px-4 py-2 rounded-xl text-slate-300 hover:bg-dark-700 transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Cancel"
                    }
                    button(classes = "px-4 py-2 rounded-xl bg-brand-cyan text-white hover:bg-brand-green transition disabled:opacity-50 disabled:cursor-not-allowed") {
                        id = "add-member-button"
                        attributes["disabled"] = "true"
                        onClickFunction = { 
                            js("addMember()")
                        }
                        +"Add Member"
                    }
                }
            }
        }
    }
}
